export default {
  humanTraining_introduction: 'Introduction',
  humanTraining_catalog: 'Directory({resourcesCount})',
  humanTraining_leran_rules: 'Completion rules',
  humanTraining_training_no_start: 'The training program has not started yet!',
  humanTraining_course_duration: 'Course credit hours',
  humanTraining_duration: 'Credit hour',
  humanTraining_have_duration: 'Credit hours earned',
  humanTraining_valid_duration: 'Not acquired',
  humanTraining_resource_duration: 'Credit hours for the resource:',
  humanTraining_own_duration: 'Credit hours earned:',
  humanTraining_book_title_mark1: "'",
  humanTraining_book_title_mark2: "'",
  humanTraining_examScore: 'Exam grade  {examScore}/{totalScore}',
  humanTraining_endDays: 'Days left to the exam: {endDays}',
  humanTraining_end_todays: 'Exam ends today',
  humanTraining_test_num: '{testNum, plural, =0 {no questions} =1 {one questions} other {# questions}} in total',
  humanTraining_service_error: 'Server error!' ,
  humanTraining_live_status: 'Replay is unavailable for the training program',
  humanTraining_total_period: 'Complete',
  humanTraining_online_period: 'Completed online',
  humanTraining_offline_period: 'Completed offline',
  humanTraining_go_learn: 'Go to learning',
  humanTraining_no_rules: 'No rules yet',
  humanTraining_exam_tasks: 'Exam task',
  humanTraining_past: 'Pass{examName}',
  humanTraining_residualExamNum: 'Qualified ({residualExamNum, plural, =0 {no chances} =1 {one chance} other {# chances}} in total)',
  humanTraining_examination: 'Obtain',
  humanTraining_max_score: '({examCountNum} chance/chances left)',
  humanTraining_exam_again: 'Retake the exam',
  humanTraining_go_exam: 'Go to take the exam',
  humanTraining_no_brief_intro: 'No brief introduction',
  humanTraining_empty_training_program: 'No training program yet',
  humanTraining_training_program_end: 'The training program has ended!',
  humanTraining_training_duration: 'Credit Hours for Training',
  humanTraining_total_time: '{periodTotal} class hours in total',
  humanTraining_total: 'Total:',
  humanTraining_sheng: 'Left'
}
